import { Flex, Text } from '@chakra-ui/react'
import { Info } from 'lucide-react'
import React from 'react'
import { QuickActionButtonVariants } from '~/components/shared/componentStyles/QuickActionButton.style'
import { QuickActionButton } from '~/components/shared/QuickActionButton'
import { Size } from '~/types/ThemeTypes'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

export const SectionHeader = ({
  title,
  tooltipText,
}: {
  title: string
  tooltipText: string
}) => {
  return (
    <Flex flexDirection="row" gap="0.5rem">
      <Text
        {...textStyles[textStyleKeys.Body2_Bold]}
        height="1.75rem"
        lineHeight="1.75rem"
        flexGrow={1}
      >
        {title}
      </Text>
      <QuickActionButton
        variant={QuickActionButtonVariants.Default_000}
        actionIcon={Info}
        size={Size.xs}
        marginTop="0.125rem"
        marginRight="-0.25rem"
        tooltipText={tooltipText}
      />
    </Flex>
  )
}
